import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

import './ColumnBoxWidget.scss'

export default ThemeMixin.extend({
  name: 'WeveColumnBoxWidget',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  render(h, { props, children, data, injections }) {
    return h(
      props.tag,
      mergeData(data, {
        staticClass: 'weve-column-box-widget',
        class: {
          'weve-column-box-widget--vertical': props.horizontal === false,
          'weve-column-box-widget--horizontal': props.horizontal,
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme !== 'light',
        },
      }),
      [
        h('div', { staticClass: 'weve-column-box-widget__content' }, [
          children,
        ]),
      ],
    )
  },
})
